// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Users_wrapper__3JpXR","deleteIcon":"Users_deleteIcon__3JSrn","imgWrapper":"Users_imgWrapper__39G53"};